module.exports = __webpack_public_path__ + "img/image9.0b2a3498.png";